/**
 * Generate initials from first and last name
 * Returns 2-character uppercase initials (first letter of each name)
 */
export function generateInitials(firstName: string, lastName: string): string {
  const first = firstName.trim().toUpperCase();
  const last = lastName.trim().toUpperCase();

  if (!first || !last) return "";

  return `${first[0]}${last[0]}`;
}
